// Function to check if a URL is a collection URL
function isCollectionURL(url) {
  return url.includes('/collections/') && !url.includes('/products/');
}

// Function to add the filter parameter to a collection link
function addAvailabilityFilter(link) {
  // Remove the last segment from the URL only if it contains "type:"
  const urlParts = link.href.split('/');
  const lastSegment = urlParts[urlParts.length - 1]; // Get the last segment

  // Check if the last segment contains "type:"
  if (lastSegment.includes("type:")) {
    urlParts.pop(); // Remove the last segment
  }
  
  const baseUrl = urlParts.join('/'); // Reconstruct the URL without the last segment

  const urlParams = new URLSearchParams(baseUrl.split('?')[1] || ''); // Extract existing parameters
  // const urlParams = new URLSearchParams(link.href.split('?')[1] || ''); // Extract existing parameters

  // Only add the filter if it's not already present
  if (!urlParams.has('filter.v.availability')) {
    urlParams.append('filter.v.availability', 1);
    const newHref = `${baseUrl}?${urlParams.toString()}`;
    link.href = newHref;
  }
}

// Function to filter all collection links on the page
function filterAllCollectionLinks() {
  const collectionLinks = document.querySelectorAll('a[href*="/collections/"]:not([href*="filter.v.availability"])');
  collectionLinks.forEach(link => {
    if (isCollectionURL(link.href)) {
      addAvailabilityFilter(link);
    }
  });
}

// Use a MutationObserver to monitor the DOM for changes and apply the filter to new elements
const collectionObserver = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    if (mutation.type === 'childList') {
      // Process newly added nodes
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          // If the node is an anchor tag itself
          if (node.tagName === 'A' && isCollectionURL(node.href)) {
            addAvailabilityFilter(node);
          }
          // If the node contains anchor tags
          const links = node.querySelectorAll && node.querySelectorAll('a');
          links.forEach(link => {
            if (isCollectionURL(link.href)) {
              addAvailabilityFilter(link);
            }
          });
        }
      });
    }
  });

  // After processing mutations, check all existing links again
  filterAllCollectionLinks();
});

// Start observing the entire document
collectionObserver.observe(document, { childList: true, subtree: true });

// Initial check for existing links on page load
filterAllCollectionLinks();

// Check when observer disconnects
collectionObserver.disconnect = function() {
  // console.log('MutationObserver disconnected: All collection links have been filtered.');
}
